import { Guideline } from '@/types/community/guideline';

export const guidelines: Guideline[] = [
  {
    id: 'GL001',
    records: [
      {
        content: '1. No diving in shallow areas\n2. Children under 12 must be accompanied by adults\n3. No glass containers allowed\n4. Proper swimwear required\n5. No running on pool deck',
        category: 'amenity_usage',
        subPolicy: 'swimming_pool',
        attachments: [
          {
            id: 'ATT001',
            name: 'pool_rules.pdf',
            type: 'application/pdf',
            size: 1024,
            path: '/documents/guidelines/GL001/pool_rules.pdf',
            url: 'https://example.com/docs/pool_rules.pdf',
            uploadedAt: new Date('2024-01-01')
          }
        ]
      },
      {
        content: '1. Maximum 2 hours per session\n2. Proper gym attire required\n3. Wipe down equipment after use\n4. No food or drinks allowed\n5. Children under 16 must be supervised',
        category: 'amenity_usage',
        subPolicy: 'fitness_center',
        attachments: []
      },
      {
        content: '1. One parking space per unit\n2. No parking in fire lanes\n3. Visitor parking available in designated areas\n4. No overnight parking for commercial vehicles\n5. Report abandoned vehicles immediately',
        category: 'parking_vehicles',
        subPolicy: 'parking_rules',
        attachments: []
      },
      {
        content: '1. Keep noise levels reasonable\n2. No parties after 10 PM\n3. Dispose of trash properly\n4. Respect common areas\n5. Report maintenance issues promptly',
        category: 'general_conduct',
        subPolicy: 'resident_behavior',
        attachments: []
      },
      {
        content: '1. All visitors must be registered\n2. Security cameras are monitored\n3. Report suspicious activity\n4. Keep doors and windows locked\n5. Emergency contacts must be updated',
        category: 'safety_security',
        subPolicy: 'security_protocols',
        attachments: []
      },
      {
        content: '1. Submit requests through the portal\n2. Emergency requests are prioritized\n3. Provide access when requested\n4. Follow up on completed work\n5. Rate service quality',
        category: 'maintenance_requests',
        subPolicy: 'request_procedures',
        attachments: []
      },
      {
        content: '1. Official communications are sent via email and portal\n2. Urgent notifications are sent via SMS\n3. Minimum 24-hour notice for changes\n4. Events are announced 7 days in advance\n5. Responses must be confirmed within 48 hours',
        category: 'announcements_notifications',
        subPolicy: 'communication_channels',
        attachments: []
      },
      {
        content: '1. Common expenses are divided equally among all units\n2. Monthly maintenance fee: $150.00 per unit\n3. Reserve fund for emergencies: 10% of monthly revenue\n4. Condo insurance covers structural damage\n5. Financial reports are published quarterly',
        category: 'common_expenses',
        subPolicy: 'utility_sharing',
        attachments: []
      }
    ],
    status: 'active',
    author: {
      id: 'EMP001',
      name: 'Community Manager',
      type: 'employee'
    },
    effectiveDate: new Date('2024-01-01'),
    version: '1.0',
    workspace: {
      id: 'WS001',
      name: 'Sunset Apartments',
      slug: 'sunset-apartments'
    }
  }
]; 